import mqtt from 'mqtt'

import { useAuthStore } from '@/store/auth'
import { useTabsStore } from '@/store/tabs'
import { checkForAppUpdate } from '@/sync/versionCheck'

const client = mqtt.connect(import.meta.env.VITE_MQTT_URL as string)

let wasDisconnected = false
let currentTopic: string | null = null

function topicFor(locationId: string) {
  return import.meta.env.VITE_MQTT_TOPIC + '-' + locationId
}

function subscribe(locationId: string) {
  const topic = topicFor(locationId)
  if (currentTopic === topic) return
  if (currentTopic) {
    client.unsubscribe(currentTopic)
  }
  currentTopic = topic
  client.subscribe(topic)
}

function unsubscribe() {
  if (!currentTopic) return
  client.unsubscribe(currentTopic)
  currentTopic = null
}

client.on('connect', () => {
  const authStore = useAuthStore()
  const locationId = authStore.selectedLocationId
  if (locationId) {
    const topic = topicFor(locationId)
    if (currentTopic !== topic) {
      currentTopic = topic
      client.subscribe(topic)
    }
    if (wasDisconnected) {
      const tabsStore = useTabsStore()
      tabsStore.refreshTabs()
    }
  }
  wasDisconnected = false
})

function markDisconnected() {
  wasDisconnected = true
}

client.on('offline', markDisconnected)
client.on('disconnect', markDisconnected)
client.on('error', markDisconnected)
client.on('end', markDisconnected)

client.on('message', (_topic, data) => {
  const message = JSON.parse(data.toString())
  if (message.type === 'update') {
    checkForAppUpdate()
    return
  }
  if (message.type !== 'event') return
  const tabsStore = useTabsStore()
  tabsStore.applyEvent(message.event)
})

export default {
  subscribe,
  unsubscribe,
  isConnected: () => client.connected
}
